"use strict";
var groups_controller_1 = require("./groups.controller");
var templateUrl = require("./groups.html");
exports.groups = {
    templateUrl: templateUrl,
    controller: groups_controller_1.GroupsController,
    controllerAs: "vm",
    bindings: {}
};



/** WEBPACK FOOTER **
 ** ./app/groups/groups.ts
 **/